import React, { useState } from 'react'

import { Expandable } from '@application/Interfaces/Atoms/Expandable'
import { HeaderNav } from '@application/Types/HeaderTypes'
import { ActionItemWithIcon } from '@src/Application/Interfaces/Features/Header/Nav/ActionItemWithIcon'

import {
    Arrow,
    Navbar,
    NavItem,
    NavItemLink,
    NavItemLinkLabel,
    NavSubMenuLinkWrapper,
    SectionTitle,
    SubMenuWrapper,
} from './MobileNav.styled'

type HandleExpandToggle = ({
    setExpanded,
    isItemExpanded,
    name,
}: {
    setExpanded: React.Dispatch<React.SetStateAction<string>>
    isItemExpanded: boolean
    name: string
}) => () => void

export const handleExpandToggle: HandleExpandToggle = (parmas) => () => {
    const { setExpanded, isItemExpanded, name } = parmas
    setExpanded(isItemExpanded ? '' : name)
}

type MobileNavProp = {
    nodes: HeaderNav[]
}

export const MobileNav = ({ nodes }: MobileNavProp): JSX.Element => {
    const [expanded, setExpanded] = useState('')

    return (
        <Navbar data-testid="mobileNavbar">
            {nodes.map((node, index) => {
                const isItemExpanded = expanded === node.label

                return (
                    <NavItem key={`mobile-nav-${index}`} $expanded={isItemExpanded}>
                        {(!node.submenu || Boolean(node.submenu.length === 0)) && (
                            <NavItemLink to={node.link}>{node.label}</NavItemLink>
                        )}
                        {node.submenu && Boolean(node.submenu.length > 0) && (
                            <NavSubMenuLinkWrapper
                                onClick={handleExpandToggle({ setExpanded, isItemExpanded, name: node.label })}
                                data-testid="submenu-toggle"
                            >
                                <NavItemLinkLabel $expanded={isItemExpanded}>{node.label}</NavItemLinkLabel>
                                <Arrow
                                    direction={isItemExpanded ? 'up' : 'down'}
                                    colorCode={isItemExpanded ? 'p500' : 'g600'}
                                />
                            </NavSubMenuLinkWrapper>
                        )}
                        {node.submenu && (
                            <Expandable isOpen={isItemExpanded}>
                                {node.submenu.map((sub) => (
                                    <SubMenuWrapper key={sub.id}>
                                        {sub.leftLinks?.map((link) => (
                                            <ActionItemWithIcon
                                                name={link.label}
                                                description={link.description?.data?.description ?? ''}
                                                url={link.link}
                                                key={`${node.label}-left-${link.label}`}
                                            />
                                        ))}
                                        {sub.rightLinks?.map((link) => (
                                            <ActionItemWithIcon
                                                name={link.label}
                                                description={link.description?.data?.description ?? ''}
                                                url={link.link}
                                                key={`${node.label}-right-${link.label}`}
                                            />
                                        ))}
                                        {sub.leftColumnLinks?.map((link) => (
                                            <ActionItemWithIcon
                                                name={link.label}
                                                description={link.description?.data?.description ?? ''}
                                                url={link.link}
                                                key={`${node.label}-left-${link.label}`}
                                            />
                                        ))}
                                        {sub.centerColumnLinks?.map((link) => (
                                            <ActionItemWithIcon
                                                name={link.label}
                                                description={link.description?.data?.description ?? ''}
                                                url={link.link}
                                                key={`${node.label}-center-${link.label}`}
                                            />
                                        ))}
                                        {sub.rightColumnLinks?.map((link) => (
                                            <ActionItemWithIcon
                                                name={link.label}
                                                description={link.description?.data?.description ?? ''}
                                                url={link.link}
                                                key={`${node.label}-right-${link.label}`}
                                            />
                                        ))}
                                        {sub.menuLinkSections?.map((menu) => {
                                            return (
                                                <React.Fragment key={menu.title}>
                                                    {menu.title && <SectionTitle>{menu.title}</SectionTitle>}
                                                    <>
                                                        {menu.link?.map((link) => (
                                                            <ActionItemWithIcon
                                                                name={link.name}
                                                                description={link.description}
                                                                icon={link.icon}
                                                                url={link.url}
                                                                tag={link.tag}
                                                                onClick={link.onClick}
                                                                key={`${menu.title}-dynamic-${link.name}`}
                                                            />
                                                        ))}
                                                    </>
                                                </React.Fragment>
                                            )
                                        })}
                                    </SubMenuWrapper>
                                ))}
                            </Expandable>
                        )}
                    </NavItem>
                )
            })}
        </Navbar>
    )
}
